var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"retrun",on:{"click":_vm.retrun}},[_vm._v(" 返回首页 ")])}
var staticRenderFns = []

export { render, staticRenderFns }